// @ts-nocheck
import { Fragment, useEffect, useRef, useState, useCallback, } from "react";
import { useNavigationStore } from "src/store/navigationStore";

// import { Canvas, useFrame, RootState } from "@react-three/fiber";
// import { Splat, OrbitControls, Line } from "@react-three/drei";
import { useHexagonSize } from "src/hooks/useHexagonSize";

import { interpolateVector3Array } from "src/utils/navigation";
import {
  Vector3Point,
  Point3D,
  filterStraightLinePoints,
} from "src/utils/three";
// import * as THREE from "three";

// import {
//   getVenueModelConfig,
//   getAltitude,
//   VenueModelConfig,
// } from "@/const/venue_model/venue_model_config";

import {
  getVenueModelConfigByVenueCode,
  getBaseUrl,
  getAltitudeByFloorName,
  getAltitudeByFloorIndex,
  getFloorNameByFloorIndex,
} from "src/utils/map-util";

import {
  getFloorIndex,
  getFloorNumber,
  getFloorNumberArray,
  getFloorString,
  getInterpolatedNumberArray,
} from "src/const/navigationConst";

import * as pc from "playcanvas";
import {
  vec3Distance,
  hexToRgbArray,
  getYAngleDegree,
  interpolateVector3,
} from "src/utils/game";
import { OrbitControls } from "@playcanvas/react/scripts";
import { useMaterial, useAppEvent } from "@playcanvas/react/hooks";
import { Application, Entity } from "@playcanvas/react";
import {
  Render,
  Camera,
  Light,
  Environment,
} from "@playcanvas/react/components";
import { useEnvAtlas } from "@playcanvas/react/hooks";
import { GSplat, Script } from "@playcanvas/react/components";
import { CameraControls } from "playcanvas/scripts/esm/camera-controls.mjs";
import { useApp, useSplat, useModel } from "@playcanvas/react/hooks";
import { Gltf } from "@playcanvas/react";

export default function NavigationTopView() {
  const [modelScaleFactorState, setModelScaleFactorState] =
    useState<number>(0.1);
  const [venueModelConfigState, setVenueModelConfigState] =
    useState<VenueModelConfig | null>(null);

  const latestProgressRef = useRef<number>(0);
  const latestCurrentLevelIndexRef = useRef<number>(0);
  const latestCurrentLevelRef = useRef<string>("");
  const targetAltitudeRef = useRef<number>(0);

  const latestNavigationPositionArrayRef = useRef<pc.Vec3[]>([]);

  const latestNavigationCameraPositionRef = useRef<pc.Vec3>(
    new pc.Vec3(0, 0, 0),
  );
  const latestNavigationCameraLookingPositionRef = useRef<pc.Vec3>(
    new pc.Vec3(0, 0, 0),
  );
  const latestNavigationPercentagePositionDictionary = useRef<
    Record<number, number[]>
  >({});

  const { HEX_WIDTH_INNER, HEX_HEIGHT_INNER } = useHexagonSize();
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth < 769);
    };

    checkIsMobile(); // Check on initial render
    window.addEventListener("resize", checkIsMobile);

    // Cleanup listener on component unmount
    return () => window.removeEventListener("resize", checkIsMobile);
  }, []);

  const DataController = () => {
    const positionArray = useNavigationStore(
      (state) => state.navigationPositionArray,
    );
    useEffect(() => {
      latestNavigationPositionArrayRef.current = positionArray;

      console.log(positionArray);
    }, [positionArray]);

    const navigationCameraPosition = useNavigationStore(
      (state) => state.navigationCameraPosition,
    );
    const navigationCameraLookingPosition = useNavigationStore(
      (state) => state.navigationCameraLookingPosition,
    );

    useEffect(() => {
      latestNavigationCameraPositionRef.current = navigationCameraPosition;
      latestNavigationCameraLookingPositionRef.current =
        navigationCameraLookingPosition;
    }, [navigationCameraPosition, navigationCameraLookingPosition]);

    const currentLevelIndex = useNavigationStore(
      (state) => state.currentLevelIndex,
    );
    useEffect(() => {
      latestCurrentLevelIndexRef.current = currentLevelIndex;
    }, [currentLevelIndex]);

    const currentVenueId = useNavigationStore((state) => state.currentVenueId);
    const currentVenue = useNavigationStore((state) => state.currentVenue);
    const currentLevel = useNavigationStore((state) => state.currentLevel);
    useEffect(() => {
      latestCurrentLevelRef.current = currentLevel;
      // if (currentVenue != "") {
      //   const venueModelConfig = getVenueModelConfig(currentVenue);
      //   if (venueModelConfig) {
      //     const altitude = getAltitude(venueModelConfig, currentLevel);
      //     targetAltitudeRef.current = altitude / venueModelConfig.scaleFactor;
      //     setVenueModelConfigState(venueModelConfig);
      //     setModelScaleFactorState(venueModelConfig.scaleFactor);
      //   }
      // }
      if (currentVenue != "") {
        const venueModelConfig = getVenueModelConfigByVenueCode(currentVenue);
        if (venueModelConfig) {
          const altitude = getAltitudeByFloorName(
            venueModelConfig,
            currentLevel,
          );
          targetAltitudeRef.current = altitude / venueModelConfig.scaleFactor;
          setVenueModelConfigState(venueModelConfig);
          setModelScaleFactorState(venueModelConfig.scaleFactor);
        }
      }
    }, [currentVenue, currentLevel]);

    const navigationPercentagePositionDictionary = useNavigationStore(
      (state) => state.navigationPercentagePositionDictionary,
    );
    useEffect(() => {
      latestNavigationPercentagePositionDictionary.current =
        navigationPercentagePositionDictionary;
    }, [navigationPercentagePositionDictionary]);

    return <></>;
  };

  const ProgressController = () => {
    const progress = useNavigationStore((state) => state.progress);
    useEffect(() => {
      latestProgressRef.current = progress;
    }, [progress]);
    return <></>;
  };

  const WalkPathsContainer = () => {
    const app = useApp();
    const isPointsSetup = useRef<boolean>(false);
    const [points, setPoints] = useState<number[][] | null>(null);

    const handleUpdate = useCallback((dt: number) => {
      if (
        !isPointsSetup.current &&
        latestNavigationPercentagePositionDictionary.current
      ) {
        let points = [];
        const entries = Object.entries(
          latestNavigationPercentagePositionDictionary.current,
        );
        for (let i = 0; i < entries.length; i++) {
          points.push(entries[i][1]);
        }
        setPoints([...points]);
        isPointsSetup.current = true;
      }
    }, []);
    useAppEvent("update", handleUpdate);

    return points != null ? <WalkPaths points={points} /> : <></>;
  };

  const WalkPaths = ({ points }: { points: number[][] }) => {
    const segments = points.slice(0, -1).map((start, i) => {
      const end = points[i + 1];
      const length = Math.hypot(
        end[0] - start[0],
        end[1] - start[1],
        end[2] - start[2],
      );
      return (
        <EachWalkPath
          key={i}
          start={start}
          end={end}
          length={length}
          pathIndex={i + 1}
          pathLength={points.length - 1}
        />
      );
    });
    return (
      <>
        {segments}
        <ExtraWalkPath points={points} />
      </>
    );
  };

  const ExtraWalkPath = ({ points }: { points: number[][] }) => {
    let _localNavigationCameraPosition;
    let isCameraNavigationPositionUpdated;

    const _startPositionRef = useRef<pc.Vec3>(new pc.Vec3(0, 0, 0));
    const _endPositionRef = useRef<pc.Vec3>(new pc.Vec3(0, 0, 0));

    const entityRef = useRef();
    useEffect(() => {
      const material = entityRef.current.render.meshInstances[0].material;
      material.emissiveMap = material.diffuseMap;
      material.emissiveIntensity = 1.0;
      material.useLighting = false;
      material.emissive.set(...hexToRgbArray("#FFFFFF")); // Red color (R,G,B) - 0 to 1 range
      material.update();
    }, []);

    const app = useApp();

    const handleUpdate = useCallback((dt: number) => {
      if (
        entityRef.current == null ||
        latestProgressRef.current == 0 ||
        latestProgressRef.current == 1
      ) {
        return;
      }
      const currentPosition = getInterpolatedNumberArray(
        latestNavigationPercentagePositionDictionary.current,
        latestProgressRef.current,
      );

      const startPosition = getFloorNumberArray(
        latestNavigationPercentagePositionDictionary.current,
        latestProgressRef.current,
      );
      _startPositionRef.current.set(
        startPosition[0],
        startPosition[1],
        startPosition[2],
      );
      _endPositionRef.current.set(
        currentPosition[0],
        currentPosition[1],
        currentPosition[2],
      );
      const length = Math.hypot(
        _endPositionRef.current.x - _startPositionRef.current.x,
        _endPositionRef.current.y - _startPositionRef.current.y,
        _endPositionRef.current.z - _startPositionRef.current.z,
      );
      entityRef.current.setPosition(_startPositionRef.current);
      entityRef.current.lookAt(_endPositionRef.current);
      entityRef.current.setLocalScale(0.5, 0.5, length);
      entityRef.current.translateLocal(0, 0, -length / 2);
      entityRef.current.enabled = true;
    }, []);
    useAppEvent("update", handleUpdate);

    return (
      <Entity ref={entityRef}>
        <Render type="box" />
      </Entity>
    );
  };

  const EachWalkPath = ({ start, end, length, pathIndex, pathLength }) => {
    const app = useApp();
    const entityRef = useRef();

    const pathCorrespondingPercentage = useRef<number>(-1);

    useEffect(() => {
      const material = entityRef.current.render.meshInstances[0].material;
      material.emissiveMap = material.diffuseMap;
      material.emissiveIntensity = 1.0;
      material.useLighting = false;
      material.emissive.set(...hexToRgbArray("#FFFFFF"));
      material.update();
      entityRef.current.setPosition(new pc.Vec3(start[0], start[1], start[2]));
      entityRef.current.lookAt(new pc.Vec3(end[0], end[1], end[2]));
      entityRef.current.setLocalScale(0.5, 0.5, length + 0.2);
      entityRef.current.translateLocal(0, 0, -length / 2);
      entityRef.current.enabled = false;
    }, []);

    const handleUpdate = useCallback((dt: number) => {
      if (entityRef.current == null) {
        return;
      }
      if (pathCorrespondingPercentage.current == -1) {
        const entries = Object.entries(
          latestNavigationPercentagePositionDictionary.current,
        );
        for (let i = 0; i < entries.length; i++) {
          if (
            end[0] == entries[i][1][0] &&
            end[1] == entries[i][1][1] &&
            end[2] == entries[i][1][2]
          ) {
            pathCorrespondingPercentage.current = entries[i][0];
          }
        }
      }
      if (latestProgressRef.current > pathCorrespondingPercentage.current) {
        entityRef.current.enabled = true;
      } else {
        entityRef.current.enabled = false;
      }
    }, []);
    useAppEvent("update", handleUpdate);

    return (
      <Entity ref={entityRef}>
        <Render type="box" />
      </Entity>
    );
  };

  const VenueSogs = () => {
    const app = useApp();
    const baseUrl = getBaseUrl();
    const floorSogParentRef = useRef();
    const floorSogRefs = useRef({});
    const allFloorSog = venueModelConfigState.floor.map((floor, i) => {
      if (floor.sog) {
        return (
          <Fragment key={floor.index}>
            <Entity>
              <SogSplat
                // url={venueModelConfigState.baseUrl + floor.sog}
                url={baseUrl + venueModelConfigState.folderPath + floor.sog}
                floorIndex={floor.index}
              ></SogSplat>
            </Entity>
          </Fragment>
        );
      } else {
        return <Fragment key={floor.index}></Fragment>;
      }
    });

    return <Entity ref={floorSogParentRef}>{allFloorSog}</Entity>;
  };

  const FloorMeshs = () => {
    const app = useApp();
    const baseUrl = getBaseUrl();
    const floorMeshParentRef = useRef();
    const allFloorMesh = venueModelConfigState.floor.map((floor, i) => {
      if (floor.mesh) {
        return (
          <Entity key={floor.index}>
            <FloorMeshModel
              meshUrl={
                baseUrl + venueModelConfigState.folderPath + floor.mesh.url
              }
              meshPosition={floor.mesh.position}
              meshRotationAngle={floor.mesh.rotationAngle}
              meshScale={floor.mesh.scale}
              meshColor={floor.mesh.color ?? "#FFFFFF"}
              meshOpacity={floor.mesh.opacity ?? 1}
              floorIndex={floor.index}
            />
          </Entity>
        );
      } else {
        return <></>;
      }
    });
    return <Entity ref={floorMeshParentRef}>{allFloorMesh}</Entity>;
  };

  const FloorMeshModel = ({
    floorIndex,
    meshUrl,
    meshPosition,
    meshRotationAngle,
    meshScale,
    meshColor,
    meshOpacity,
  }: {
    floorIndex: number;
    meshUrl: string;
    meshPosition: number[];
    meshRotationAngle: number[];
    meshScale: number[];
    meshColor: string;
    meshOpacity: number;
  }) => {
    const meshEntityRef = useRef();
    const { asset: meshAsset } = useModel(meshUrl);
    const color = hexToRgbArray(meshColor);

    const changeMaterial = (entity) => {
      if (entity == null) {
        return;
      }
      console.log("change material");
      const renders = entity.findComponents("render");
      renders.forEach((render) => {
        if (render.meshInstances) {
          render.meshInstances.forEach((meshInstance) => {
            const currentMaterial = meshInstance.material;
            const material = currentMaterial.clone();
            meshInstance.material = material;
            if (material) {
              material.emissiveMap = material.diffuseMap;
              material.emissiveIntensity = 1.0;
              material.emissive = new pc.Color(color[0], color[1], color[2]);
              material.useLighting = false;
              material.update();
            }
          });
        }
      });
    };
    useEffect(() => {
      if (meshAsset && meshEntityRef.current) {
        requestAnimationFrame(() => {
          changeMaterial(meshEntityRef.current);
        });
      }
    }, [meshAsset]);

    return (
      <Entity
        ref={meshEntityRef}
        position={[
          meshPosition[0] / modelScaleFactorState,
          meshPosition[1] / modelScaleFactorState,
          meshPosition[2] / modelScaleFactorState,
        ]}
        rotation={meshRotationAngle}
        scale={[
          meshScale[0] / modelScaleFactorState,
          meshScale[1] / modelScaleFactorState,
          meshScale[2] / modelScaleFactorState,
        ]}
      >
        <Render type="asset" asset={meshAsset} />
      </Entity>
    );
  };

  const SogSplat = ({
    url,
    floorIndex,
  }: {
    url: string;
    floorIndex: number;
  }) => {
    const app = useApp();
    const floorRef = useRef();

    const handleUpdate = useCallback((dt: number) => {
      if (
        latestCurrentLevelIndexRef.current != null &&
        floorRef.current != null
      ) {
        if (latestCurrentLevelIndexRef.current == floorIndex) {
          floorRef.current.enabled = true;
        } else {
          floorRef.current.enabled = false;
        }
      }
    }, []);
    useAppEvent("update", handleUpdate);

    const { asset } = useSplat(url);
    return (
      <Entity
        enabled={true}
        ref={floorRef}
        rotation={[180, 0, 0]}
        position={[0, 0, 0]}
        scale={[
          1 / modelScaleFactorState,
          1 / modelScaleFactorState,
          1 / modelScaleFactorState,
        ]}
      >
        <GSplat asset={asset} />
      </Entity>
    );
  };

  const MainObject = () => {
    const app = useApp();
    const mainObjectEntityRef = useRef();
    const cameraScriptRef = useRef();
    const cameraRef = useRef();
    let _localProgress;
    const _finalCameraPositionRef = useRef<pc.Vec3>(new pc.Vec3(0, 0, 0));
    const _finalCameraLookingPositionRef = useRef<pc.Vec3>(
      new pc.Vec3(0, 0, 0),
    );

    let _navigationCameraPosition;
    let isNavigationCameraPositionUpdated;
    let _navigationCameraLookingPosition;
    let isNavigationCameraLookingPositionUpdated;

    const handleUpdate = useCallback((dt: number) => {
      if (!cameraScriptRef.current) {
        return;
      }
      isNavigationCameraPositionUpdated = false;
      if (
        _navigationCameraPosition !=
          latestNavigationCameraPositionRef.current &&
        (latestNavigationCameraPositionRef.current.x != 0 ||
          latestNavigationCameraPositionRef.current.y != 0 ||
          latestNavigationCameraPositionRef.current.z != 0)
      ) {
        _navigationCameraPosition = latestNavigationCameraPositionRef.current;
        isNavigationCameraPositionUpdated = true;
      }
      isNavigationCameraLookingPositionUpdated = false;
      if (
        _navigationCameraLookingPosition !=
          latestNavigationCameraLookingPositionRef.current &&
        (latestNavigationCameraLookingPositionRef.current.x != 0 ||
          latestNavigationCameraLookingPositionRef.current.y != 0 ||
          latestNavigationCameraLookingPositionRef.current.z != 0)
      ) {
        _navigationCameraLookingPosition =
          latestNavigationCameraLookingPositionRef.current;
        isNavigationCameraLookingPositionUpdated = true;
      }
      if (
        isNavigationCameraPositionUpdated ||
        isNavigationCameraLookingPositionUpdated
      ) {
        _finalCameraPositionRef.current.set(
          _navigationCameraPosition.x,
          _navigationCameraPosition.y + 50,
          _navigationCameraPosition.z,
        );
        _finalCameraLookingPositionRef.current.set(
          _navigationCameraPosition.x,
          _navigationCameraPosition.y,
          _navigationCameraPosition.z - 0.001,
        );
      }

      cameraScriptRef.current.reset(
        _finalCameraLookingPositionRef.current,
        _finalCameraPositionRef.current,
      );
    }, []);
    useAppEvent("update", handleUpdate);

    useEffect(() => {
      const defaultCameraLookingPosition = new pc.Vec3(
        venueModelConfigState.defaultPosition[0] / modelScaleFactorState,
        venueModelConfigState.defaultPosition[1] / modelScaleFactorState,
        venueModelConfigState.defaultPosition[2] / modelScaleFactorState,
      );
      const defaultPosition = new pc.Vec3(
        venueModelConfigState.defaultPosition[0] / modelScaleFactorState,
        venueModelConfigState.defaultPosition[1] / modelScaleFactorState + 50,
        venueModelConfigState.defaultPosition[2] / modelScaleFactorState,
      );
      mainObjectEntityRef.current.setPosition(defaultPosition);
      cameraScriptRef.current.reset(
        defaultCameraLookingPosition,
        defaultPosition,
      );
    }, []);

    return (
      <Entity ref={mainObjectEntityRef}>
        <Entity>
          <Camera clearColor="#000000" />
          <Script ref={cameraScriptRef} script={CameraControls} />
        </Entity>
      </Entity>
    );
  };

  const PlaycanvasScene = () => {
    const app = useApp();
    return (
      <>
        <WalkPathsContainer />
        <VenueSogs />
        <FloorMeshs />
        <Environment exposure={1.0} luminance={0.4} />
        <MainObject />
      </>
    );
  };

  const TopDownScene = () => {
    return (
      <Application>
        {venueModelConfigState != null && modelScaleFactorState > 0 ? (
          <PlaycanvasScene />
        ) : (
          <></>
        )}
      </Application>
    );
  };

  const DirectionLight = () => {
    const navigationAngle = useNavigationStore(
      (state) => state.navigationAngle,
    );
    return (
      <div
        className={`fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2`}
        style={{ transform: `rotate(${navigationAngle + 180}deg)` }}
      >
        {/*<div className="fixed w-[60px] h-[50px] left-1/2 -translate-x-1/2 -translate-y-full bg-gradient-to-t from-[#FFFFFFDD] to-[#FFFFFF00] [clip-path:polygon(0_0,100%_0,60%_100%,40%_100%)]"></div>*/}
        <div className="fixed w-[80px] left-1/2 -translate-x-1/2 -translate-y-full">
          <img
            src="/assets/spotlight.png"
            className="w-full h-full object-cover"
          />
        </div>
      </div>
    );
  };

  const LogoDot = () => {
    const navigationAngle = useNavigationStore(
      (state) => state.navigationAngle,
    );
    return (
      <div style={{ transform: `rotate(${navigationAngle + 180}deg)` }}>
        <img
          src="/assets/icon_logo_dot.png"
          className="w-full h-full object-cover"
        />
      </div>
    );
  };

  return (
    <div
      id="navi-top-view-parent"
      className={`relative hex-crop ${isMobile ? "mobile" : "desktop"}`}
      style={{
        width: `${HEX_WIDTH_INNER}px`,
        height: `${HEX_HEIGHT_INNER}px`,
      }}
    >
      <div
        className={`relative left-0 bottom-0 h-[100%] w-[100%] transform rotate-180 overflow-hidden`}
      >
        <div
          className={`absolute h-[100%] w-[100%] overflow-hidden bg-black`}
        />

        <div
          id="div-above-canvas"
          className="absolute left-0 bottom-0"
          style={{
            width: `${HEX_WIDTH_INNER}px`,
            height: `${HEX_HEIGHT_INNER}px`,
          }}
        >
          <DataController />
          <ProgressController />
          {/*<SecondaryCanvas />*/}
          <TopDownScene />
        </div>

        <div className="absolute top-1/2 left-1/2 w-[20px] h-[20px] -translate-x-1/2 -translate-y-1/2">
          <DirectionLight />
          <LogoDot />
        </div>
      </div>
    </div>
  );
}
